import * as React from "react";
import { DayPicker, useDayPicker } from "react-day-picker";
import { cs } from "date-fns/locale";
import { cn } from "../../lib/utils";
import { ChevronLeft, ChevronRight } from "lucide-react";

const btnCls =
    "inline-flex items-center justify-center h-7 w-7 rounded-md border border-gray-200 bg-white p-0 opacity-70 hover:opacity-100 hover:bg-gray-100 transition-colors shrink-0";

function MonthCaption({ calendarMonth }) {
    const { previousMonth, nextMonth, goToMonth } = useDayPicker();
    const label = calendarMonth.date.toLocaleDateString("cs-CZ", { month: "long", year: "numeric" });

    return (
        <div className="flex items-center justify-between w-full px-1 pt-1 pb-1">
            <button
                type="button"
                className={btnCls}
                disabled={!previousMonth}
                onClick={() => previousMonth && goToMonth(previousMonth)}
                aria-label="Předchozí měsíc"
            >
                <ChevronLeft className="h-4 w-4" />
            </button>
            <span className="text-sm font-medium capitalize">{label}</span>
            <button
                type="button"
                className={btnCls}
                disabled={!nextMonth}
                onClick={() => nextMonth && goToMonth(nextMonth)}
                aria-label="Další měsíc"
            >
                <ChevronRight className="h-4 w-4" />
            </button>
        </div>
    );
}

function Calendar({ className, classNames, showOutsideDays = true, ...props }) {
    return (
        <DayPicker
            locale={cs}
            showOutsideDays={showOutsideDays}
            className={cn("p-3", className)}
            classNames={{
                months: "flex flex-col gap-2",
                month: "flex flex-col gap-4",
                month_caption: "w-full",
                nav: "hidden",
                month_grid: "w-full border-collapse",
                weekdays: "flex",
                weekday: "text-muted-foreground w-8 font-normal text-[0.8rem] text-center",
                weeks: "flex flex-col gap-1 mt-2",
                week: "flex",
                day: "relative p-0 text-center text-sm flex-none w-8 h-8 focus-within:relative focus-within:z-20",
                day_button: cn(
                    "inline-flex items-center justify-center w-8 h-8 rounded-md text-sm font-normal hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#082359] transition-colors"
                ),
                selected: "[&>button]:bg-[#082359] [&>button]:text-white [&>button]:hover:bg-[#061a42] [&>button]:hover:text-white",
                today: "[&>button]:bg-gray-100 [&>button]:font-semibold",
                outside: "[&>button]:text-muted-foreground [&>button]:opacity-50",
                disabled: "[&>button]:text-muted-foreground [&>button]:opacity-30 [&>button]:pointer-events-none",
                hidden: "invisible",
                ...classNames,
            }}
            components={{ MonthCaption }}
            {...props}
        />
    );
}
Calendar.displayName = "Calendar";

export { Calendar };
